import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import AvatarEditor from 'react-avatar-edit'
import Avatar from 'react-avatar'
import UserApiManager from '../../api/services/UserApiManager'
import DrupalApiManager from '../../api/services/DrupalApiManager'
import { useTranslation } from 'react-i18next'

function UserFormEdit() {
    const { t } = useTranslation()
    const location = useLocation()
    const { userEdit } = location?.state || {}
    const [validated, setValidated] = useState(false)
    const [username, setUsername] = useState('')
    const [avatar, setAvatar] = useState('')
    const [preview, setPreview] = useState('')
    const [firstName, setFirstName] = useState('')
    const [correo, setCorreo] = useState('')
    const [avatarFid, setAvatarFid] = useState(null)

    const navigate = useNavigate()
    useEffect(() => {
        if (userEdit) {
            setUsername(userEdit.username)
            setFirstName(userEdit.firstName)
            setCorreo(userEdit.correo)
            setAvatar(userEdit.avatar)
        }
    }, [])
    const handleSubmit = async (event) => {
        const form = event.currentTarget
        if (form.checkValidity() === false) {
            event.preventDefault()
            event.stopPropagation()
            setValidated(true)
            return
        }

        event.preventDefault()
        setValidated(true)

        const data = {
            name: [
                {
                    value: username,
                },
            ],
            field_first_name: [{ value: firstName }],
            mail: [
                {
                    value: correo,
                },
            ],
        }

        if (avatarFid) {
            data.user_picture = [
                {
                    target_id: avatarFid,
                },
            ]
        }

        var result = await UserApiManager.editUser(data)

        if (result) {
            toast.success(t('alerts.user_edited'), {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
            setTimeout(() => {
                localStorage.removeItem('userData')
                localStorage.clear()
                navigate('/user-pages/login')
            }, 2000)
        } else {
            toast.error(t('alerts.user_edit_error'), {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }
    }

    function onClose() {
        setAvatar(preview)
        uploadImage(preview)
    }

    async function uploadImage(image) {
        const imageResultFid = await DrupalApiManager.uploadFile(
            image,
            'user',
            'user',
            'user_picture',
            true
        )
        setAvatarFid(imageResultFid)
    }

    function onCrop(preview) {
        setPreview(preview)
    }

    function onBeforeFileLoad(elem) {
        // if (elem.target.files[0].size > 71680) {
        //     alert('El archivo es muy grande')
        //     elem.target.value = ''
        // }
    }

    return (
        <div className="col-12 grid-margin stretch-card">
            <ToastContainer />
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">{t('edit_my_profile')}</h4>
                    <p className="card-description">{t('edition_profile')}</p>
                    <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                    >
                        <Form.Group>
                            <Form.Label>{t('avatar')}</Form.Label>
                            <div className="mb-4 row">
                                <div className="col-lg-6">
                                    <AvatarEditor
                                        width={200}
                                        height={200}
                                        onCrop={onCrop}
                                        onClose={onClose}
                                        onBeforeFileLoad={onBeforeFileLoad}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <Avatar
                                        src={avatar}
                                        name={username}
                                        size={200}
                                        email={correo}
                                        round={true}
                                        color="#3f50f6"
                                    />
                                </div>
                            </div>
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom01"
                        >
                            <Form.Label>{t('names_title')}</Form.Label>
                            <Form.Control
                                type="text"
                                className="form-control"
                                value={firstName}
                                required
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder={t('names_placeholder')}
                            />
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom01"
                        >
                            <Form.Label>{t('auth.login.username')}</Form.Label>
                            <Form.Control
                                type="text"
                                className="form-control"
                                value={username}
                                required
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder={t('username_placeholder')}
                            />
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom02"
                        >
                            <Form.Label>{t('email_title')}</Form.Label>
                            <Form.Control
                                type="email"
                                className="form-control"
                                value={correo}
                                required
                                onChange={(e) => setCorreo(e.target.value)}
                                placeholder={t('email_placeholder')}
                            />
                        </Form.Group>
                        <Button
                            variant="btn btn-primary"
                            className="me-2"
                            type="submit"
                        >
                            {t('button.save')}
                        </Button>
                        <Button
                            variant="btn btn-light"
                            onClick={() => navigate(-1)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default UserFormEdit
